export const PRODUCT_LIST_ID = 'product-list';
